var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='contentWrap'><div class='row " + extraClasses + "'></div></div>");
	},
	innerWrap: function (selector, extraClasses) {
		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selector).wrapInner("<div class='contentWrap " + extraClasses + "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.carsCarousel = {
	init: function() {
		if ( $(window).width() < 768 ) {
			site.owl.init('#promo-2 > ul', {
				loop: true,
				dots: true,
				stopOnHover: true,
				autoplay: true,
				items: 1,
			});
		}
	}
};

site.topbanner = {
	init: function () {
		if($.trim($('#topbar .contentWrap').html())==='') {
			$('#topbar').hide();
		}
	}
}

site.carwaySearch = {
	init: function() {
		$isChecked = $('#sameReturnAsPickup');
		$body = $('body');
		$isChecked.change(function() {
			$body.toggleClass('displayReturnStation');

			if ($body.hasClass('displayReturnStation')) {
				$pickupStation = $('#elm_pickupStation .lmnt > input');
				if ($body.hasClass('is')) {
					$pickupStation.attr('placeholder', 'Afhendingarstaður');
				}
				else {
					$pickupStation.attr('placeholder', 'Pick-up location');
				}
			}
		});

		$isChecked = $('#elm_vehicleCategoryId .lmnt > label input:checked').parent();
		if ($isChecked) {
			$isChecked.addClass('selected');
		}
		else {
			$('#elm_vehicleCategoryId .lmnt > label:first').addClass('selected');
		}

		$('#elm_vehicleCategoryId input').each(function() {
			$(this).on('click', function(e) {
				$('#elm_vehicleCategoryId .lmnt label.selected').removeClass('selected');
				$(this).parent().addClass('selected');
			});
		});
	}
};

// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	// Responsive tables
	if ($('body').is('.frontpage')) {
		site.carsCarousel.init();
	}
	site.topbanner.init();
	site.carwaySearch.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function (e) {
		e.preventDefault();
		window.location = '/moya';
	});

	site.layout.rowWrap('.rowbegin', '.rowend');
	site.layout.rowWrap('.strevdabegin', '.strevdaend');
	site.layout.innerWrap('.innerwrap');

	site.owl.init('#owl-hero', {
		autoplay: 1,
		autoplayHoverPause: 1,
		autoplayTimeout: 8000,
		loop: 1,
		responsiveClass:true,
		responsive:{
			0:{
				items:1,
				dots: false
			},
			600:{
				items:1,
				dots: true
			},
			992:{
				items:1,
				dots: true
			}
		}
	});

	// Carway: Make clicking pricebox trigger price button
	$('.price.entry--hasButton', '#carway .entry__prices').on('click', function(e) {
		$(this).find('.price__button').trigger('click');
	});
});
